import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45eda4ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid" }
const _hoisted_2 = {
  key: 0,
  class: "grid-col-sm-12"
}
const _hoisted_3 = {
  key: 1,
  class: "grid-col-sm-12"
}
const _hoisted_4 = {
  key: 2,
  class: "grid-col-sm-12"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mb-4 mt-3" }, "Lista de Imágenes que Inspiran", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "searchTerm",
  class: "d-flex mb-3"
}, "¿Quieres buscar algo nuevo? ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-primary my-3"
}, "Buscar", -1))
const _hoisted_8 = { class: "grid" }
const _hoisted_9 = { class: "alegra-card-container" }
const _hoisted_10 = { class: "alegra-card p-1" }
const _hoisted_11 = { class: "alegra-card__title" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingFile = _resolveComponent("LoadingFile")!
  const _component_ErrorFile = _resolveComponent("ErrorFile")!
  const _component_WinnerModal = _resolveComponent("WinnerModal")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("article", _hoisted_2, [
          _createVNode(_component_LoadingFile)
        ]))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("article", _hoisted_3, [
            _createVNode(_component_ErrorFile, { message: _ctx.error }, null, 8, ["message"])
          ]))
        : _createCommentVNode("", true),
    (!_ctx.loading && !_ctx.error)
      ? (_openBlock(), _createElementBlock("article", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("form", {
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleGetNewImages && _ctx.handleGetNewImages(...args)), ["prevent"]))
          }, [
            _hoisted_6,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "searchTerm",
              class: "d-flex form-control",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
              placeholder: "Buscar imágenes",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.searchTerm]
            ]),
            _hoisted_7
          ], 32),
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sellerWithImages, (seller) => {
              return (_openBlock(), _createElementBlock("div", {
                key: seller,
                class: "grid-col-xs-11 grid-col-sm-12 grid-col-md-4 grid-col-lg-4"
              }, [
                _createElementVNode("section", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("h4", _hoisted_11, _toDisplayString(seller.name) + "-" + _toDisplayString(seller.points ?? 0) + " puntos ", 1),
                    (seller.clickable)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "mt-3",
                          onClick: ($event: any) => (_ctx.handleUpdateSellerPoints(seller))
                        }, " Votar ", 8, _hoisted_12))
                      : (_openBlock(), _createElementBlock("p", _hoisted_13, "Votado")),
                    _createElementVNode("img", {
                      class: "alegra-card__image",
                      src: seller.image,
                      alt: seller.alt_description
                    }, null, 8, _hoisted_14)
                  ])
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.contestEnded)
      ? (_openBlock(), _createBlock(_component_WinnerModal, {
          key: 3,
          show: _ctx.contestEnded,
          winnerName: _ctx.winner?.name || '',
          onProceed: _ctx.handleContinue
        }, null, 8, ["show", "winnerName", "onProceed"]))
      : _createCommentVNode("", true)
  ]))
}